import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShoppingCart, AlertTriangle } from 'lucide-react';
import { Button } from './ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from './ui/dialog';

/**
 * MixedCartWarningModal - Shows when user tries to mix regular and preorder items
 * 
 * @param {boolean} isOpen - Whether the modal is open
 * @param {function} onClose - Close handler
 * @param {string} message - The warning message to display
 */
const MixedCartWarningModal = ({ isOpen, onClose, message }) => {
  const navigate = useNavigate();

  const handleGoToCart = () => {
    onClose();
    navigate('/warenkorb');
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center justify-center mb-4">
            <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center">
              <AlertTriangle className="w-8 h-8 text-amber-600" />
            </div>
          </div>
          <DialogTitle className="text-center text-xl font-bold text-gray-900">
            Warenkorb nicht leer
          </DialogTitle>
          <DialogDescription className="text-center text-gray-600 mt-2 text-base">
            {message}
          </DialogDescription>
        </DialogHeader>
        
        <div className="mt-6 space-y-3">
          <Button
            onClick={handleGoToCart}
            className="w-full bg-red-600 hover:bg-red-700 text-white py-3 text-base font-semibold"
          >
            <ShoppingCart className="w-5 h-5 mr-2" />
            Zum Warenkorb
          </Button>
          
          <Button
            variant="outline"
            onClick={onClose}
            className="w-full border-gray-300 text-gray-700 hover:bg-gray-50 py-3"
          >
            Abbrechen
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default MixedCartWarningModal;
